import { Card, Group, Text, Stack, Tooltip } from '@mantine/core'
import { Button } from '../Common/Button'
import { Claim } from '../../types/claim'
import { formatDate } from '../../utils/formatters'

export interface ClaimCardProps {
  claim: Claim
  onConnect: (claimNumber: string) => void
  highlighted?: boolean
  connected?: boolean
}

export function ClaimCard({ claim, onConnect, highlighted, connected }: Readonly<ClaimCardProps>) {
  const brokerOrInsurer = claim.broker || claim.insurer || claim.primaryClient
  const showThirdRow = Boolean(brokerOrInsurer)

  return (
    <Card
      padding="xs"
      withBorder
      style={highlighted ? { borderColor: 'var(--mantine-color-brand-6)', borderWidth: 2 } : undefined}
    >
      <Stack gap={4}>
        <Group justify="space-between" wrap="nowrap">
          <Stack gap={0} style={{ minWidth: 0 }}>
            <Tooltip label={claim.claimTitle} withArrow openDelay={400} multiline maw={300}>
              <Text fw="var(--mantine-font-weight-semibold)" fz="sm" truncate>
                {claim.claimTitle}
              </Text>
            </Tooltip>
          </Stack>
          <Button
            variant={connected ? 'filled' : 'outline'}
            color={connected ? 'success.6' : undefined}
            label="Connect"
            size="xs"
            radius={0}
            style={{ flexShrink: 0 }}
            aria-label={connected ? `Disconnect claim ${claim.claimNumber}` : `Connect claim ${claim.claimNumber}`}
            onClick={() => onConnect(claim.claimNumber)}
          />
        </Group>
        <Group gap="sm">
          <Text fz="xs" c="var(--link-color)" td="underline">
            {claim.claimNumber}
          </Text>
          <Text fz="xs" c="dimmed">
            DOL: {formatDate(claim.dateOfLoss) ?? 'N/A'}
          </Text>
        </Group>
        {showThirdRow && (
          <Group gap="sm">
            <Text fz="xs" c="dimmed">
              {claim.broker ? `Broker: ${claim.broker}` : `Insurer: ${claim.insurer || claim.primaryClient}`}
            </Text>
            {claim.insured && (
              <Text fz="xs" c="dimmed">
                Insured: {claim.insured}
              </Text>
            )}
          </Group>
        )}
      </Stack>
    </Card>
  )
}
